import { mapMutations } from 'vuex';
import { globalConfig_api } from "../http/api";

export default {
    async install(Vue, store){
        const response = await globalConfig_api();
        console.log(store);
        store.commit('setAppConfig', response.data);   
        
    }
}


// WEBPACK FOOTER //
// ./src/common/globalApi.js